import type theme from '#build/ui/checkbox'
import type { DeepPartial } from '@nuxt/ui'

const checkbox: DeepPartial<typeof theme> = {
  slots: {
    root: 'relative flex items-start',
    base: 'text-cvt-text-black focus:outline-hidden flex shrink-0 items-center justify-center rounded-sm ring-2 focus-visible:outline-1 focus-visible:outline-offset-1',
    container: 'flex items-center',
    wrapper: 'ms-2',
    icon: 'size-4 shrink-0',
    label: 'block font-normal text-(--ui-text)',
    description: 'text-cvt-text-black',
  },
  variants: {
    color: {
      neutral: 'ring-cvt-cloud-800 focus-visible:outline-cvt-cloud-800',
      error: 'bg-cvt-burgundy-100 ring-cvt-burgundy-600',
    },
    size: {
      xl: {
        base: 'size-5',
        container: 'h-6',
        wrapper: 'cvt-typography-body',
      },
    },
    required: {
      true: {
        label: `after:text-cvt-burgundy-600 after:ms-0.5 after:content-['*']`,
      },
    },
    disabled: {
      true: {
        base: 'bg-cvt-cloud-500 cursor-not-allowed opacity-100',
        label: 'text-cvt-cloud-800 cursor-not-allowed opacity-100',
        description: 'text-cvt-cloud-800 cursor-not-allowed opacity-100',
      },
    },
  },
  compoundVariants: [
    {
      color: 'neutral',
      checked: true,
      class: {
        base: 'bg-gradient-to-t from-[#AC005F] to-[#9F1193] ring-0',
        icon: 'text-white',
      } as any,
    },
  ],
  defaultVariants: {
    size: 'xl',
    color: 'neutral',
  },
}

export default checkbox
